import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { HomeHero } from "../components/HomeHero";
import { HowItWorks } from "../components/HowItWorks";
import { Features } from "../components/Features";
import { AsiaSection } from "../components/AsiaSection";
import { ExistingUserSection } from "../components/ExistingUserSection";
import { Sectors } from "../components/Sectors";
import { Pricing } from "../components/Pricing";

export default function HomePage() {
  return (
    <>
      <Seo {...SEO.home} />
      <HomeHero />
      <HowItWorks />
      <Features />
      <AsiaSection />
      <ExistingUserSection />
      <Sectors />
      <Pricing />
    </>
  );
}
